import sctService from '@/services/sctService';
import pdiService from '@/services/pdiService';

const limit = 25;
export default {
  namespaced: true,
  state: {
    itemDeptNoList: [],
    favoriteItemNoList: [],
    // 兌禮卡片用
    favoriteItemNos: [],
    keyword: '',
    limit,
    // 撈取上架中且前台可顯示
    activeType: 3,
    orderType: 0,
    cartList: [],
    redeemTime: null,
  },
  mutations: {
    set(state, { name, value }) {
      state[name] = value;
    },
    push(state, { name, value }) {
      state[name].push(value);
    },
    delete(state, { name }) {
      state[name] = null;
    },
    // 設定分類商品編號列表
    setItemDeptNoList(state, value) {
      state.itemDeptNoList = value;
      // 設定搜尋上限，恢復預設
      state.limit = limit;
      // 清空最愛商品編號列表
      state.favoriteItemNoList = [];
    },
    // 設定最愛商品編號列表
    setFavoriteItemNoList(state, value) {
      state.favoriteItemNoList = value;
      // 設定搜尋上限，以最愛列表數量決定
      state.limit = value.length;
      // 清空分類商品編號列表
      state.itemDeptNoList = [];
    },
    // 更新購物車對應商品數量
    setCartRedeemItemQty(state, { index, qty }) {
      state.cartList[index].qty = qty;
    },
    // 加入購物車
    addCartRedeemItem(state, payload) {
      state.cartList.push(payload);
    },
    // 刪除購物車對應商品
    delCartRedeemItem(state, index) {
      state.cartList.splice(index, 1);
    },
    // 更新最愛兌禮商品
    updateFavoriteItem(state, no) {
      const index = state.favoriteItemNos.findIndex((x) => x === no);
      if (index === -1) {
        state.favoriteItemNos.push(no);
      } else {
        state.favoriteItemNos.splice(index, 1);
      }
    },
  },
  actions: {
    // 取得兌禮商品列表
    getRedeemItems: ({ rootState }, payload) => {
      payload.companyId = rootState.companyId;
      return pdiService.getRedeemItems(payload).toPromise();
    },
    // 更新會員的最愛兌禮商品資料
    updateMemberFavoriteRedeemItems: ({ commit, rootState }, no) => {
      const headers = { accessToken: rootState.accessToken };
      return sctService.updateMemberFavoriteRedeemItems({ no }, headers)
        .toPromise()
        .then((res) => {
          commit('updateFavoriteItem', no);
          return res;
        });
    },
    // 更新會員的購物車資料
    updateRedeemItemsCart: ({ commit, state, rootState }, payload) => {
      const headers = { accessToken: rootState.accessToken };
      return sctService.updateRedeemItemsCart(payload, headers)
        .toPromise()
        .then((res) => {
          // 更新state裡的購物車
          const index = state.cartList.findIndex((x) => x.no === payload.no);
          if (index === -1) {
            commit('addCartRedeemItem', payload);
          } else if (payload.qty === 0) {
            commit('delCartRedeemItem', index);
          } else {
            commit('setCartRedeemItemQty', { index, qty: payload.qty });
          }

          return res;
        });
    },
    // 取得會員的兌禮商品兌換時間
    getRedeemTime: ({ commit, state, rootState }) => {
      // 若state中沒有會員的兌禮商品兌換時間promise，呼叫API
      if (!state.redeemTime) {
        const headers = { accessToken: rootState.accessToken };
        const redeemTime = sctService.getRedeemTime(headers)
          .toPromise()
          .then((res) => res.response.data);
        commit('set', { name: 'redeemTime', value: redeemTime });
      }

      // 若state中已有會員的兌禮商品兌換時間的promise，直接回傳
      return state.redeemTime;
    },
    postRedeemOrderItemTranfer({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberIdFrom: payload.memberIdFrom,
        memberIdTo: payload.memberIdTo,
        orderNo: payload.orderNo,
        seqNo: payload.seqNo,
      };
      return sctService.postRedeemOrderItemTranfer(body).toPromise();
    },
  },
};
